

<template>

  <group-container :title="element.label" :tooltip="element.describe">
    <template #title>
        {{element.label}}  <form-element-tooltip :element="element"></form-element-tooltip>
    </template>
    <el-table border style="width: 100%;border-radius: 6px;padding-bottom: 10px;margin-bottom: 20px" :height="element.attrs.height"
              :header-cell-style="{color:'#181A1D'}" @dragstart="e=>e.stopPropagation()">
      <el-table-column label="标题" v-if="element.attrs.showTitle"></el-table-column>
      <template v-for="(item,index) in element.attrs.showColumns" :key="index">
        <el-table-column :label="item.label"></el-table-column>
      </template>
    </el-table>
  </group-container>



</template>

<script>
import GroupContainer from "@/components/common/groupContainer.vue";
import FormElementTooltip from "@/components/common/formElementTooltip.vue";

export default {
  components: {FormElementTooltip, GroupContainer},
  props: {
    context: {
      type: Object,
      default: () => {
      }
    },
    element: {
      type: Object,
      default: () => {
      }
    },
    parent: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      data: this.element
    }
  }


}

</script>

<style scoped lang="scss">

</style>